export default "__VITE_ASSET__69b6cd44__"